import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Placement } from 'react-bootstrap/types';

export type HelpProps = {
  placement: Placement;
};

export const Help: React.FC<React.PropsWithChildren<HelpProps>> = ({ placement, children }) => {
  const renderTooltip = (props: any) => (
    <Tooltip id="tooltip" {...props}>
      <div style={{ whiteSpace: 'pre-line', maxWidth: '50em' }}>{children}</div>
    </Tooltip>
  );

  return (
    <OverlayTrigger placement={placement} delay={{ show: 100, hide: 100 }} overlay={renderTooltip}>
      <FontAwesomeIcon className="question-icon" icon="question-circle" />
    </OverlayTrigger>
  );
};
